import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Flex } from "sprout-ui-primitives";
import styled from "styled-components";
import { themeGet } from "sprout-ui-theme";
import { Button } from "../Button";
import { Form, Input as BaseInput } from "../Form";
import { BottomSheetBackdrop, BottomSheetSheet } from "../BottomSheet";
import { getIsLargePointerDevice } from "../utils";
const Input = styled(BaseInput)`
  border: 0;
  background: transparent;

  font-weight: ${themeGet("fontWeights.bold")};
  font-size: ${themeGet("fontSizes.3")}px;

  padding: 16px;
  height: auto;
`;
const NewItemInputMobile = (props)=>{
    const { onSubmit , onCancel , initialInputValue , placeholder  } = props;
    const [inputValue, setInputValue] = useState(initialInputValue || "");
    const inputValueRef = useRef(inputValue);
    const handleChange = (event)=>{
        const { value  } = event.target;
        inputValueRef.current = value;
        setInputValue(value);
    };
    const inputRef = useRef(null);
    useEffect(()=>{
        if (inputRef.current) {
            if (getIsLargePointerDevice()) inputRef.current.select();
            else inputRef.current.focus();
        }
    }, []);
    const handleSubmit = ()=>{
        if (!inputValueRef.current) return;
        const description = inputValueRef.current;
        onSubmit(description);
    };
    const handleKeyDown = (event)=>{
        if (event.key === "Escape") onCancel();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BottomSheetBackdrop, {
                onClick: onCancel
            }),
            /*#__PURE__*/ _jsxs(BottomSheetSheet, {
                as: Form,
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ _jsx(Input, {
                        ref: inputRef,
                        value: inputValue,
                        onChange: handleChange,
                        onKeyDown: handleKeyDown,
                        placeholder: placeholder
                    }),
                    /*#__PURE__*/ _jsx(Flex, {
                        justifyContent: "flex-end",
                        pb: 3,
                        px: 3,
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "bright-blue",
                            type: "submit",
                            children: "Save"
                        })
                    })
                ]
            })
        ]
    });
};
export default NewItemInputMobile;
